(function () {
    'use strict';

    angular
        .module('iMatApp')
        .controller('PreviouslyUploadedModelsController', PreviouslyUploadedModelsController);

    PreviouslyUploadedModelsController.$inject = ['$scope', '$q', '$timeout', 'uploadedModelsService'];

    function PreviouslyUploadedModelsController($scope, $q, $timeout, uploadedModelsService) {
        var vm = this;

        vm.items = null;
        vm.totalCount = 0;

        vm.isReady = false;
        vm.hasError = false;
        vm.isDataLoading = true;
        vm.pageNumber = 1;
        vm.pageSize = 6;

        vm.query = null;
        vm.dateRange = {
            startDate: null,
            endDate: null
        };

        vm.load = load;     // you should call this method on first time
        vm.reload = reload;
        vm.refresh = refresh;
        vm.resetPageAndRefresh = resetPageAndRefresh;

        vm.hasItems = hasItems;
        vm.getPagesCount = getPagesCount;

        $scope.$watch('vm.pageNumber', pageNumberChanged);
        $scope.$watch('vm.dateRange', filtersChanged);
        $scope.$watch('vm.query', filtersChanged);

        var canceler = null;

        // ---------------------------------------------------------------------------------------------

        function load() {
            vm.isReady = false;
            refresh();
        }

        function reload() {
            resetData();
            resetPaging();

            load();
        }

        function hasItems() {
            return vm.items && vm.items.length > 0;
        }

        function getPagesCount() {
            return Math.ceil(vm.totalCount / vm.pageSize);
        }

        function pageNumberChanged(newVal, oldVal) {
            if (angular.isUndefined(newVal) || angular.equals(newVal, oldVal)) {
                return;
            }

            if (vm.items) {
                refresh();
            }
        }

        function filtersChanged(newVal, oldVal) {
            if (angular.isUndefined(newVal) || angular.equals(newVal, oldVal)) {
                return;
            }

            resetPageAndRefresh();
        }

        // ---------------------------------------------------------------------------------------------

        function refresh() {

            vm.hasError = false;
            vm.isDataLoading = true;

            if (canceler) {
                canceler.resolve();
                canceler = null;
            }

            canceler = $q.defer();

            uploadedModelsService.getModelsByCurrentUser(vm.pageNumber, vm.pageSize, null, getFilters(), canceler.promise)
                .then(function (data) {
                    vm.items = data.UploadedModels;
                    vm.totalCount = data.Pagination.TotalCount;

                    vm.isReady = true;
                    vm.isDataLoading = false;

                    if (canceler) {
                        canceler.reject();
                        canceler = null;
                    }

                    normalizePageNumber();

                })
                .catch(function (reason) {
                    if (reason !== 'CANCELED') {
                        resetData();

                        vm.isReady = true;
                        vm.hasError = true;
                        vm.isDataLoading = false;
                    }
                });
        }

        function resetPageAndRefresh() {
            if (vm.pageNumber !== 1) {
                resetPaging();
            } else {
                refresh();
            }
        }

        function resetData() {
            vm.items = null;
            vm.totalCount = 0;
        }

        function resetPaging() {
            vm.pageNumber = 1; // $watch on pageNumber field will call refresh() function.
        }

        function getFilters() {
            var filters = [];

            if (vm.dateRange.startDate || vm.dateRange.endDate) {
                filters.push({ name: 'UploadDate', value: vm.dateRange.startDate, operator: imat.FilterOperator.GreaterThanOrEqual });
                filters.push({ name: 'UploadDate', value: vm.dateRange.endDate, operator: imat.FilterOperator.LessThanOrEqual });
            }

            if (vm.query && vm.query.length) {
                filters.push({ name: 'FileName', value: vm.query, operator: imat.FilterOperator.ContainsLike });
            }

            return filters;
        }

        function normalizePageNumber() {
            if (vm.pageNumber < 1) {
                vm.pageNumber = 1;
            }

            if (vm.items && vm.items.length === 0) {
                var lastPageNumber = getPagesCount();
                if (lastPageNumber !== 0) {
                    vm.pageNumber = lastPageNumber;
                }
            }
        }
    }
})();
